import React from 'react';

import { Typography } from '@mui/material';

import { FIELD_REPLACED_LABEL } from '../../EntityAuditHistory.constants';
import { EntityAuditHistoryTestIds } from '../../EntityAuditHistory.testIds';

const FieldReplacedValue = () => (
  <Typography
    color="text.secondary"
    data-testid={EntityAuditHistoryTestIds.FIELD_REPLACED}
    variant="regular14"
  >
    {FIELD_REPLACED_LABEL}
  </Typography>
);

export default FieldReplacedValue;
